/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Overview_Plan_DescriptionInputs */

const en_settings_overview_plan_description = /** @type {(inputs: Settings_Overview_Plan_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly plan, if you have one`)
};

/**
* | output |
* | --- |
* | "Monthly plan, if you have one" |
*
* @param {Settings_Overview_Plan_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_overview_plan_description = /** @type {((inputs?: Settings_Overview_Plan_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Overview_Plan_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_overview_plan_description(inputs)
});
export { settings_overview_plan_description as "settings.overview.plan_description" }